import Button from '@atlaskit/button/standard-button';
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle, ModalTransition } from '@atlaskit/modal-dialog';
import { Icon } from '@css-xp/base';
import { EntitlementDetails } from '@css-xp/graphtypes/src/generated-types-new';
import React from 'react';

export const DeleteProductWarningDialog = ({
  isOpen,
  onClose,
  onConfirm,
  entitlement,
}: {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  entitlement: EntitlementDetails;
}) => {
  const { productName, entitlementNumber } = entitlement;
  return (
    <ModalTransition>
      {isOpen && (
        <Modal onClose={onClose}>
          <ModalHeader>
            <ModalTitle>
              <Icon type="error" /> <span className="warning-confirm-header">{`Confirm product data deletion`}</span>
            </ModalTitle>
          </ModalHeader>
          <ModalBody>
            <div>
              {`You’re about to schedule the deletion of all product data for ${productName} ${' '} ${entitlementNumber} . Once this action is performed, the product data will be scheduled for deletion in 15 days. After that time, the subscription can’t be reactivated and the data can’t be recovered.`}
            </div>
          </ModalBody>
          <ModalFooter>
            <div id="warning-confirm-footer">
              <Button appearance="subtle" onClick={onClose} className="cancel-button" testId="cancel-warning-dialog">
                Cancel
              </Button>
              <Button appearance="danger" onClick={onConfirm} autoFocus testId="change-warning-dialog">
                Schedule deletion
              </Button>
            </div>
          </ModalFooter>
        </Modal>
      )}
    </ModalTransition>
  );
};
